<template>
  <div style="position:relative;margin-top:80px;margin-bottom:20px">
    <h2><span class="function-title">包机报价</span></h2>
    <br />
    <div v-if="success===1">
      <div class="empty-form">
        <div class="success">
          <Card style="width:500px;margin: 0 auto;">
            <p slot="title" style="font-size:22">
              <Icon type="ios-checkmark-circle-outline" size="20"></Icon>包机报价申请完成
            </p>
            <p></p>
            <p>
              <h4>请等待,我司员工报价后将与您联系。</h4>
            </p>
          </Card>
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <Steps :current="current">
        <Step class="blue" title="行程信息" content="填写行程信息" style="width: 25%"></Step>
        <Step class="blue" title="机型信息" content="选择目标机型" style="width: 25%"></Step>
        <Step class="blue" title="联系信息" content="填写联系方式" style="width: 25%"></Step>
        <Step class="blue" title="信息确认" content="对信息进行确认" style="width: 25%"></Step>
      </Steps>
      <div class="seperate-15"></div>
      <div class="seperate-15"></div>
      <div class="seperate-15"></div>

      <div v-show="current===0">
        <Card>
          <Row>
            <i-col span="12">
              <h4>行程信息</h4>
            </i-col>
            <i-col span="8" class="small-12 columns text-right">
              <input type="hidden" id="dataTripTotalLegs" name="data[Trip][TotalLegs]" value="1">
              <button type="button" class="button orange small" id="addLegButton" @click="addLeg">
                增加航程
              </button>
            </i-col>
          </Row>
          <div id="MultiLegs">
            <div is="leg-item" ref="legItems" class="row" @on-remove-leg="removeLeg" v-for="(leg, index) in legs"
              v-bind:id="'leg'+leg.itemId" v-bind:key="index" v-bind:index="index" v-bind:leg-key="leg.itemId"></div>
          </div>
        </Card>
      </div>
      <div v-show="current===1" name="aircrafttype" style="width:100%">
        <Card>
          <div>
            <Table border stripe :columns="aircraftTypeCols" :data="aircraftTypes"></Table>
          </div>
        </Card>
      </div>
      <div v-show="current===2" name="contact" style="width:100%">
        <Card>
          <p class="callout success">联系人信息</p>
          <div class="row">
            <div class="small-2 columns">
              <label>&nbsp;</label>
              <h6>联系人</h6>
            </div>
            <div class="small-10 columns">
              <div class="row">
                <div class="small-6 large-6 xlarge-3 columns">
                  <label class="" for="dataLeadName" :class="{required: contactHasError}">姓名 <span
                      class="required">*</span>
                  </label>
                  <Input prefix="ios-contact" type="text" @on-blur="checkContactValid" v-model="contact" value=""
                    required="" />
                </div>
                <div class="small-6 large-6 xlarge-3 columns">
                  <label class="" :class="{required: emailHasError}" for="dataLeadEmail">Email <span
                      class="required">*</span> <span class="ajax-dot-loader" id="email-processing">&nbsp;</span>
                  </label>
                  <Input type="email" @on-blur="checkEmailValid" required="" v-model="email" />
                  <div class="email-error"></div>
                  <div class="email-suggest"></div>
                </div>
                <div class="small-6 large-6 xlarge-3 columns">
                  <label class="" for="dataLeadTelephone" :class="{required: telHasError}">电话
                    <span class="required">*</span>
                  </label>
                  <div class="intl-tel-input allow-dropdown">
                    <div class="flag-container">
                      <div class="selected-flag" tabindex="0" title="China (中国): +86">
                        <div class="iti-flag cn"></div>
                        <div class="iti-arrow"></div>
                      </div>
                    </div><Input type="tel" v-model="tel" @on-blur="checkTelValid($event.target.value)"
                      title="Please use the following phone number format: <br/>+Country Code - Area Code - Phone Number e.g. <br/>+1-123-456-7890"
                      value="" required="" autocomplete="off" placeholder="+86 131 2345 6789" />
                  </div>
                </div>
                <div class="small-6 large-6 xlarge-3 columns">
                  <label for="dataLeadCompany">公司</label>
                  <Input type="text" v-model="company" />
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
      <div v-show="current===3" name="confirm" style="width:100%">
        <Card>
          <p class="callout" v-if="commitHasError" style="color:red">信息提交出现错误，请稍后再试！或直接联系客服。</p>
          <p>行程信息</p>
          <div>
            <Table :columns="selectedLegCols" :data="legs">
              <template slot-scope="{ row, index }" slot="deptDate">
                <span>{{ getDepDateString(row.deptDate,row.deptHour) }}</span>
              </template>
            </Table>
          </div>
          <p>机型选择</p>
          <div>
            <Table border stripe :columns="selectedAircraftTypeCols" :data="selectedAircraftTypeData"></Table>
          </div>
          <p>联系信息</p>
          <div>
            <Table border stripe :columns="contactCols" :data="contactData"></Table>
          </div>
        </Card>
      </div>
      <div style="width:100%">
        <br />
        <strng v-if="preorderHasError" style="color:red">行程预订失败，请稍后再试！</strng>
        <button type="button" class="button blue small" @click="prev" v-if="current>0 && current<4">上一步</button>
        <button type="button" class="button blue small" @click="next()" v-if="current<3">下一步</button>
        <div v-show="current===3" style="height:300px">
          <wxlogin v-for="item in wxapps" :appid="item.appid" v-bind:key="item.appid" :scope="item.scope" :redirect_uri="item.redirect_uri" :href="item.href" :state="state"></wxlogin>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
  import {
    emailValid,
    telValid,
    getDateStringByDate
  } from '@/api/utils-api'
  import LegItem from '_c/leg-item'
  import SIdentify from '_c/sidentify'
  import {
    legsPreorder
  } from '@/api/net-api'
  import wxlogin from 'vue-wxlogin'
  import {
    mapActions
  } from 'vuex'
  import {
    Base64,
    encode
  } from 'js-base64'
  export default {
    name: 'jet-qutoes',
    components: {
      LegItem,
      SIdentify,
      wxlogin
    },
    data() {
      return {
        wxapps: [],
        preorderHasError: false,
        idenfycodeRight: true,
        formCode: '',
        identifyCode: '',
        identifyCodes: '1234567890abcdefghilmnpqrstuvwxyzABCDEFGHLMNQRSTUVWXYZ',
        commitHasError: false,
        currentid: 0,
        success: 0,
        current: 0,
        title: '',
        contact: '',
        email: '',
        tel: '',
        company: '',
        emailHasError: false,
        telHasError: false,
        contactHasError: false,

        legs: [{
          itemId: 1,
          deptCity: '',
          deptCode: '',
          destCity: '',
          destCode: '',
          deptDate: '',
          deptHour: '08:00',
          pax: 0
        }],
        aircraftTypeCols: [{
            title: '型号',
            key: 'model'
          },
          {
            title: '类型',
            key: 'luxury'
          },
          {
            title: '乘坐人数',
            key: 'pax'
          },
          {
            title: '选择',
            key: 'id',
            width: 70,
            align: 'center',
            render: (h, params) => {
              let id = params.row.id;
              let flag = false;
              if (this.currentid === id) {
                flag = true
              } else {
                flag = false
              }
              let self = this
              return h('div', [
                h('Radio', {
                  props: {
                    value: flag
                  },
                  on: {
                    'on-change': () => {
                      self.currentid = id
                    }
                  }
                })
              ])
            }
          }
        ],
        aircraftTypes: [
          {
            model: '湾流-450',
            luxury: '经济型',
            pax: '6-8人',
            id: 1
          }
        ],
        selectedLegCols: [{
            title: '出发城市',
            key: 'deptCity'
          },
          {
            title: '到达城市',
            key: 'destCity'
          },
          {
            title: '出发时间',
            slot: 'deptDate'
          },
          {
            title: '人数',
            key: 'pax'
          }
        ],
        selectedAircraftTypeCols: [{
            title: '型号',
            key: 'model'
          },
          {
            title: '类型',
            key: 'luxury'
          },
          {
            title: '乘坐人数',
            key: 'pax'
          }
        ],
        selectedAircraftTypeData: [],
        contactCols: [{
            title: '联系人',
            key: 'contact'
          },
          {
            title: '邮箱',
            key: 'email'
          },
          {
            title: '电话',
            key: 'tel'
          },
          {
            title: '公司',
            key: 'company'
          }
        ],
        contactData: [{
          contact: '',
          email: '',
          tel: '',
          company: ''
        }],
        appid: 'wx95d4548d5b883e09',
        scope: 'snsapi_login',
        redirect_uri: 'http%3A%2F%2Fwww.baonengjet.com%2Fweixin%2Flogin',
        href: 'http%3A%2F%2Fwww.baonengjet.com%2Fuploads%2Fwx-login.css',
        state: '123'
      }
    },
    mounted() {
      //this.refreshCode()
      this.handleAuthorize()
    },
    methods: {
      ...mapActions([
        'handleAuthorize',
      ]),
      next() {
        if (this.current === 3) {
          this.current = 0

        } else {
          if (this.current === 0) {
            if (!this.checkLegsValid()) {
              return
            }
          } else if (this.current === 1) {
            this.selectedAircraftTypeData = this.aircraftTypes.filter(item => item.id == this.currentid)
            
            if(this.selectedAircraftTypeData.length === 0) {
              return
            }
          } else if (this.current === 2) {
            if (!this.checkContactPageValid()) {
              return
            }
            this.getState()
            if(this.wxapps.length==0) {
              this.wxapps.push({'appid': this.appid, 'scope': this.scope,'redirect_uri': this.redirect_uri, 'href': this.href, 'state': this.state})
            }
          }
          this.current += 1
        }
      },
      prev() {
        if (this.current > 0) {
          this.current -= 1
        }
        if(this.wxapps.length>0) {
          this.wxapps.splice(0,1)
        }
      },
      commit() {
        this.preorderHasError = false
        if (this.checkIdenfyCode()) {
          var data = {
            legs: this.legs,
            aircraftType: this.selectedAircraftTypeData[0].model,
            contact: {
              contactName: this.contact,
              tel: this.tel,
              email: this.email,
              company: this.company
            }
          }

          this.$Loading.start()
          legsPreorder(data)
            .then(res => {
              console.log(res)
              this.$Loading.finish()
              this.success = 1
            })
            .catch(err => {
              this.$Loading.finish()
              this.preorderHasError = true
              console.log("save preorder failed")
            });
        }
      },
      addLeg: function () {
        this.legs.push({
          itemId: this.nextTodoId++,
          title: this.newTodoText
        })
        this.newTodoText = ''
      },
      removeLeg: function ({
        indexId
      }) {
        this.legs.splice(indexId, 1)
      },
      handleSubmit: function () {
        console.log('handlesubmit')
      },
      checkLegsValid: function () {
        for (let i = 0; i < this.$refs.legItems.length; i++) {
          //console.log(this.todos[i].title)
          if (!this.$refs.legItems[i].checkLegValid()) {
            return false
          } else {
            this.legs[i].deptCity = this.$refs.legItems[i].lDepCity()
            this.legs[i].destCity = this.$refs.legItems[i].lArrCity()
            this.legs[i].deptCode = this.$refs.legItems[i].lDepCityCode()
            this.legs[i].destCode = this.$refs.legItems[i].lArrCityCode()
            this.legs[i].deptDate = this.$refs.legItems[i].lDepDate
            this.legs[i].deptHour = this.$refs.legItems[i].lDepHour
            this.legs[i].pax = this.$refs.legItems[i].lPax
          }
        }
        return true
      },
      checkContactValid: function () {
        this.contactHasError = (this.contact === '')
        return !this.contactHasError
      },
      checkEmailValid: function () {
        this.emailHasError = (this.email === '' || !emailValid(this.email))
        return !this.emailHasError
      },
      checkTelValid: function (value) {
        this.telHasError = (this.tel === '' || !telValid(this.tel))
        return !this.telHasError
      },
      checkContactPageValid: function () {
        let result = this.checkContactValid() & this.checkEmailValid() & this.checkTelValid()
        if (result) {
          this.contactData[0].contact = this.contact
          this.contactData[0].email = this.email
          this.contactData[0].tel = this.tel
          this.contactData[0].company = this.company
        }
        return result
      },
      checkIdenfyCode: function () {
        let value = this.formCode.toLowerCase()
        if (this.identifyCode.toLowerCase() !== value) {
          this.formCode = ''
          this.refreshCode()
          this.idenfycodeRight = false
          return false
        } else {
          this.idenfycodeRight = true
          return true
        }
      },
      getDepDateString: function (d, h) {
        return getDateStringByDate(d) + ' ' + h
      },
      // 生成一个随机数
      randomNum(min, max) {
        return Math.floor(Math.random() * (max - min) + min)
      },
      refreshCode() {
        this.identifyCode = ''
        this.makeCode(this.identifyCodes, 6)
        this.idenfycodeRight = true
      },
      makeCode(o, l) {
        for (let i = 0; i < l; i++) {
          this.identifyCode += this.identifyCodes[
            this.randomNum(0, this.identifyCodes.length)
          ]
        }
      },
      getState() {
        console.log('getstate')
        var data = {
          legs: this.legs,
          aircraftType: this.selectedAircraftTypeData[0].model,
          contact: {
            contactName: this.contact,
            tel: this.tel,
            email: this.email,
            company: this.company
          }
        }
        let o = JSON.stringify(data)
        let o2 = Base64.encode(o, false)
        this.state = encodeURIComponent(o2)
      }
    },

  }

</script>
<style scoped>
  @import '../assets/styles/app.css';

</style>



// WEBPACK FOOTER //
// src/view/jet-quotes.vue